document.addEventListener("DOMContentLoaded", function(event) {

    // FAQ question animations
    const faqQuestions = document.querySelectorAll('.wp-block-create-block-swiftpay-faq .faq-item .faq-question');

    faqQuestions.forEach(question => {
        question.addEventListener('click', function() {
            const faqItem = this.closest('.faq-item');
            const faqAnswer = faqItem.querySelector('.faq-answer');

            if (!faqItem.classList.contains('faq-open')) {
                faqItem.classList.add('faq-open');
                faqAnswer.style.display = 'block';

                setTimeout(() => {
                    faqAnswer.style.maxHeight = faqAnswer.scrollHeight + 'px';
                }, 10);
            } else {
                faqAnswer.style.maxHeight = '0px';
                setTimeout(() => {
                    faqAnswer.style.display = 'none';
                    faqItem.classList.remove('faq-open');
                }, 200);
            }
        });
    });

    // Appearance animations
    var mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        // GSAP faq column animations
        var faqContainer = document.querySelector('.wp-block-create-block-swiftpay-faq');
        var faqHeading = document.querySelector('.faq-header h2');
        var faqHeadingAnimated = new SplitType(faqHeading);
        var faqParagraph = document.querySelector('.faq-header p');

        var faqItemsContainer = document.querySelector(".faq-content");
        var faqItems = gsap.utils.toArray(".faq-content .faq-item");

        function initFaqScrollAnimation() {
            var faqScrollAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: faqContainer,
                    start: "top +=90%",
                    end: "bottom bottom"
                }
            });

            var headingAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut"
            };

            gsap.fromTo(faqHeadingAnimated.chars, {
                y: 20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                ease: "power3.inOut",
                stagger: 0.01,
                scrollTrigger: {
                    trigger: faqContainer,
                    start: "top +=85%",
                    end: "bottom bottom"
                }
            });

            faqScrollAnimationTimeline
                .from(faqParagraph, {...headingAnimationProps, delay: 0.1});


            var faqScrollItemsAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: faqItemsContainer,
                    start: "top +=80%",
                    end: "bottom bottom"
                },
            });

            var itemsAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut",
                stagger: 0.2
            };

            faqScrollItemsAnimationTimeline.from(faqItems, itemsAnimationProps);
        }

        initFaqScrollAnimation();
    });
});
